import { z } from 'zod'

export const ReportTypeSchema = z.enum(['commission', 'loads-data'])

export type ReportType = z.infer<typeof ReportTypeSchema>

export const ReportStatusSchema = z.enum(['completed', 'failed', 'pending', 'processing'])

export type ReportStatus = z.infer<typeof ReportStatusSchema>

export const ReportDownloadKindSchema = z.enum(['file', 'link'])

export type ReportDownloadKind = z.infer<typeof ReportDownloadKindSchema>

export const REPORT_TYPE_LABEL: Record<ReportType, string> = {
  commission: 'Loads commission report',
  'loads-data': 'Loads data report',
}

export const GetReportDownloadSchema = z.object({
  kind: ReportDownloadKindSchema,
  url: z.string(),
})

export type GetReportDownload = z.infer<typeof GetReportDownloadSchema>

export const GetReportSchema = z.object({
  created_at: z.coerce.date(),
  date_from: z.string(),
  date_to: z.string(),
  download: GetReportDownloadSchema.nullish(),
  generated_at: z.coerce.date().nullish(),
  id: z.number(),
  status: ReportStatusSchema,
  type: ReportTypeSchema,
  uuid: z.string(),
})

export type GetReport = z.infer<typeof GetReportSchema>

export const REPORT_MAX_PERIOD_DAYS = 366

const ApiDateSchema = z.iso.date()

export const CreateReportBodySchema = z.object({
  date_from: ApiDateSchema,
  date_to: ApiDateSchema,
})

export type CreateReportBody = z.infer<typeof CreateReportBodySchema>

const MS_PER_DAY = 86_400_000

const dayDiff = (from: Date, to: Date) => Math.round((to.getTime() - from.getTime()) / MS_PER_DAY)

export const CreateReportFormSchema = z
  .object({
    date_from: z.date('Start date is required'),
    date_to: z.date('End date is required'),
  })
  .refine(value => value.date_to >= value.date_from, {
    message: 'The end date must be the same as or later than the start date.',
    path: ['date_to'],
  })
  .refine(value => dayDiff(value.date_from, value.date_to) <= REPORT_MAX_PERIOD_DAYS, {
    message: `The period cannot be longer than ${REPORT_MAX_PERIOD_DAYS} days.`,
    path: ['date_to'],
  })
